import { FC } from "react";
import { useTranslation } from "next-i18next";
import {
  ContactFormInputType,
  i18translateType,
} from "../../../../@types/types-body";

export const ContactFormInput: FC<ContactFormInputType> = ({
  id,
  namespace,
  model,
  placeholder,
  type,
  onChange,
  name,
}) => {
  const { t }: i18translateType = useTranslation(namespace);
  const validateModel = (eventInput: string) => {
    onChange((prevState: any) => ({
      ...prevState,
      [name]: {
        input: eventInput,
        isValid: true,
      },
    }));
  };
  return (
    <div className="mb-6" key={`form-input-${id}`}>
      <label
        htmlFor={name}
        className="hidden block mb-2 text-sm font-medium text-gray-900"
      ></label>
      <div className="flex">
        <input
          type={type}
          id={name}
          name={name}
          key={name}
          value={model.model}
          className="
                       bg-gray-50
                       rounded-lg border border-gray-900 placeholder-black text-black
                       focus:ring-crowlyn-mid hover:border-crowlyn-mid
                       block flex-1 min-w-0 w-full text-sm border-gray-300 p-3  "
          placeholder={t(`${placeholder}`)}
          onChange={(event) => validateModel(event.target.value)}
        />
      </div>
    </div>
  );
};
